import dayjs from 'dayjs'
import { Button, Pagination, Table, Tag, Tooltip } from 'antd'
import { Paginate } from 'stores/types/common.type'
import { Corporate } from 'stores/types/corporate.types'
import { mergeStringArray } from 'utilities/common'
import { PAGE_SIZE_OPTION } from 'constants/common'
import { useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

const { Column } = Table
interface IProps {
  loading: boolean
  dataSource: Corporate[]
  pagination: Paginate
  changePage: (page: number, pageSize: number) => void
  onRefresh?: (selectedRowKeys: any[]) => void
}
const CorporateTable = ({ loading, dataSource, pagination, changePage }: IProps) => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState<boolean>(loading)

  useEffect(() => {
    setIsLoading(loading)
  }, [loading])

  const onChangePage = (page: number, pageSize: number) => {
    changePage(page, pageSize)
  }

  const renderCorporateName = (record) => {
    const html = (
      <div>
        <div className='text-sm font-bold '>{record.corporateName.th}</div>
        <div className='text-sm text-gray-500 '>{record.corporateName.en}</div>
      </div>
    )
    return (
      <Tooltip title={html}>
        <div className='line-clamp-2 overflow-hidden'>{html}</div>
      </Tooltip>
    )
  }

  const renderCorporateAddress = (record) => {
    const html = (
      <div className=''>
        <div className=''>{record.streetAddress1}</div>
        <div className='text-gray-500'>
          {mergeStringArray([
            record.district,
            record.subdistrict,
            record.province,
            record.postalCode,
          ])}
        </div>
      </div>
    )

    return (
      <Tooltip title={html}>
        <div className='line-clamp-2 overflow-hidden'>{html}</div>
      </Tooltip>
    )
  }

  return (
    <>
      <Table
        loading={isLoading}
        pagination={false}
        rowKey={(record) => `${record?._id}`}
        dataSource={dataSource}
        className='mt-2 mb-2'
      >
        <Column
          title='No.'
          className='break-word column-corporate-no'
          ellipsis
          width={120}
          render={(record) => (
            <Tooltip title={record.corporateNumber}>{record.corporateNumber}</Tooltip>
          )}
        />
        <Column
          title='Name'
          className='break-word column-crop-name'
          align='left'
          width={250}
          render={(record) => renderCorporateName(record)}
        />

        <Column
          title='Tax ID'
          className='column-crop-no'
          ellipsis
          width={120}
          render={(record) => <Tooltip title={record.taxId}>{record.taxId}</Tooltip>}
        />

        <Column
          title='Address'
          className='break-word column-type'
          align='left'
          width={250}
          render={(record) => renderCorporateAddress(record)}
        />

        <Column
          title='Group'
          className='break-word column-type'
          align='center'
          render={(record) =>
            record?.corporateGroup ? (
              <Tag className='m-auto'>{record?.corporateGroup?.name}</Tag>
            ) : (
              <></>
            )
          }
        />

        <Column
          title='Last Updated'
          className='break-word column-create-at'
          render={(record) => dayjs(record?.updatedAt).format('DD MMM YYYY')}
        />
        <Column
          className='column-more-detail'
          render={(item) => (
            <Tooltip title='More Detail'>
              <Button
                type='link'
                className='btn-view'
                onClick={() => navigate(`/corporate/${item._id}`)}
                automate-test='btn-edit-corporate'
              >
                View
              </Button>
            </Tooltip>
          )}
        />
      </Table>

      <Pagination
        showSizeChanger
        onChange={onChangePage}
        onShowSizeChange={onChangePage}
        pageSizeOptions={PAGE_SIZE_OPTION}
        pageSize={pagination.limit}
        current={pagination.currentPage}
        total={pagination.total}
        className='text-right'
        locale={{ ['items_per_page']: '' }}
      />
    </>
  )
}

export default CorporateTable
